import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router-dom';
import { SessionContext } from '../../context/Session';
import PageHeader from '../../components/PageHeader';
import canvas from '../../constants/canvas';
import flowers from '../../constants/flowers';
import wreaths from '../../constants/wreaths';
import AddressForm from '../Checkout/AddressForm';
import S3FileUpload from 'react-s3/lib/ReactS3';
import ProgressBar from '@ramonak/react-progress-bar';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import * as emailjs from 'emailjs-com';

export default function CustomOrderDescription() {
  let history = useHistory();
  const { shipping } = React.useContext(SessionContext);
  const [type, setType] = React.useState(history.location.state?.type);
  const [pics, setPics] = React.useState([]);
  const [canvasSize, setCanvasSize] = React.useState('');
  const [canvasColor, setCanvasColor] = React.useState([]);
  const [canvasTexture, setCanvasTexture] = React.useState('');
  const [canvasTopCoat, setCanvasTopCoat] = React.useState('');
  const [wreathSize, setWreathSize] = React.useState('');
  const [wreathColor, setWreathColor] = React.useState([]);
  const [wreathTheme, setWreathTheme] = React.useState('');
  const [flowerSize, setFlowerSize] = React.useState('');
  const [flowerVaseColor, setFlowerVaseColor] = React.useState('');
  const [flowerFlowerColor, setFlowerFlowerColor] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [completed, setCompleted] = React.useState(0);
  const [onePhoto, setOnePhoto] = React.useState(false);
  const [description, setDescription] = React.useState('');
  const [submitForApprovalDisabled, setSubmitForApprovalDisabled] =
    React.useState(true);

  React.useEffect(() => {
    if (
      type === 'canvas' &&
      (canvasSize ||
        canvasColor ||
        canvasTexture ||
        canvasTopCoat ||
        description)
    ) {
      setSubmitForApprovalDisabled(false);
    } else if (
      type === 'wreath' &&
      (wreathSize || wreathColor || wreathTheme || description)
    ) {
      setSubmitForApprovalDisabled(false);
    } else if (
      type === 'flowers' &&
      (flowerSize || flowerVaseColor || flowerFlowerColor || description)
    ) {
      setSubmitForApprovalDisabled(false);
    } else {
      setSubmitForApprovalDisabled(true);
    }
  }, [
    canvasSize,
    canvasColor,
    canvasTexture,
    canvasTopCoat,
    wreathSize,
    wreathColor,
    wreathTheme,
    flowerSize,
    flowerVaseColor,
    flowerFlowerColor,
    description,
  ]);

  const submitForApproval = () => {
    const url = `https://sheline-art-website-api.herokuapp.com/custom-orders/`;
    const chosenSize =
      type === 'canvas'
        ? canvasSize
        : type === 'wreath'
        ? wreathSize
        : flowerSize;
    // const url = `http://localhost:3001/custom-orders/`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...shipping,
        type,
        size: chosenSize,
        texture: canvasTexture,
        top_coat: canvasTopCoat,
        flower_color: flowerFlowerColor,
        vase_color: flowerVaseColor,
        pics,
        color: type === 'canvas' ? canvasColor : wreathColor,
        description,
      }),
    };
    fetch(url, requestOptions).then((response) => {
      console.log(response);
      if (response.status === 200) {
        const templateParams = {
          name: shipping.firstName,
          email: shipping.email,
        };
        emailjs.send(
          'service_aqwqfqf',
          'template_r0acrw7',
          templateParams,
          'user_eA4SwTxRO6tlvA4TufCPY'
        );
        history.push(`/`);
      }
    });
  };

  const pageHeader = {
    title: `Custom Orders`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };

  const config = {
    bucketName: 'shelineartwebsite',
    dirName: 'custom-orders',
    region: 'us-east-1',
    accessKeyId: 'AKIAQGEVZMWALHW54BSS',
    secretAccessKey: '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',
  };

  const upload = async (e) => {
    e.preventDefault();
    let fileArr = e.target.files;
    let done = 0;
    let total = fileArr.length;
    let picNames = [];
    if (total > 1) {
      setCompleted(1);
      for (let i = 0; i < fileArr.length; i++) {
        await S3FileUpload.uploadFile(fileArr[i], config)
          .then((data) => {
            console.log(data);
            picNames.push(data.key);
            done++;
            setCompleted(Math.round((done / total) * 100));
          })
          .catch((err) => {
            setErrorMessage(err);
          });
      }
    } else {
      setOnePhoto(true);
      await S3FileUpload.uploadFile(fileArr[0], config)
        .then((data) => {})
        .catch((err) => {
          setErrorMessage(err);
        });
    }
    setPics(picNames);
    setSuccessMessage('You have uploaded your photos successfully!');
    setCompleted(0);
    setOnePhoto(false);
  };

  return (
    <React.Fragment>
      <Container
        disableGutters
        maxWidth='2xl'
        component='main'
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: 12,
          alignItems: 'center',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
      >
        <PageHeader post={pageHeader} />
        <Typography
          sx={{ my: 1, fontSize: 40, mt: { xs: 5, md: 0 } }}
          variant='primary'
          component='div'
          align='center'
        >
          {type === 'flowers' && 'Custom Flower Arrangements'}
          {type === 'wreaths' && 'Custom Wreaths'}
          {type === 'canvas' && 'Custom Canvas Art'}
        </Typography>
        <Container
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-around',
            flexDirection: 'row',
          }}
        >
          {type === 'canvas' && (
            <React.Fragment>
              <Grid container justifyContent='center'>
                <Grid item>
                  <FormControl sx={{ mb: 1 }}>
                    <InputLabel id='demo-simple-select-label'>Size</InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      sx={{ width: 250 }}
                      value={canvasSize}
                      label='Size'
                      onChange={(event) => setCanvasSize(event.target.value)}
                    >
                      {canvas.sizes.map((size) => (
                        <MenuItem value={size} key={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl sx={{ mb: 1 }}>
                    <InputLabel id='demo-simple-select-label'>Color</InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      sx={{ width: 350 }}
                      value={canvasColor}
                      multiple
                      label='Color'
                      onChange={(event) => setCanvasColor(event.target.value)}
                    >
                      {canvas.colors.map((size) => (
                        <MenuItem value={size} key={size}>
                          {size.toUpperCase()}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl sx={{ mb: 1 }}>
                    <InputLabel id='demo-simple-select-label'>
                      Texture
                    </InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      sx={{ width: 250 }}
                      value={canvasTexture}
                      label='Texture'
                      onChange={(event) => setCanvasTexture(event.target.value)}
                    >
                      {canvas.textures.map((size) => (
                        <MenuItem value={size} key={size}>
                          {size.toUpperCase()}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl sx={{ mb: 1 }}>
                    <InputLabel id='demo-simple-select-label'>
                      Top Coat
                    </InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      sx={{ width: 250 }}
                      value={canvasTopCoat}
                      label='Top Coat'
                      onChange={(event) => setCanvasTopCoat(event.target.value)}
                    >
                      {canvas.topCoats.map((topCoat) => (
                        <MenuItem value={topCoat} key={topCoat}>
                          {topCoat.toUpperCase()}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
          {type === 'wreaths' && (
            <React.Fragment>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>Size</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 250 }}
                    value={wreathSize}
                    label='Size'
                    onChange={(event) => setWreathSize(event.target.value)}
                  >
                    {wreaths.sizes.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size}"
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>Color</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 350 }}
                    value={wreathColor}
                    multiple
                    label='Color'
                    onChange={(event) => setWreathColor(event.target.value)}
                  >
                    {wreaths.colors.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>Theme</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 250 }}
                    value={wreathTheme}
                    label='Theme'
                    onChange={(event) => setWreathTheme(event.target.value)}
                  >
                    {wreaths.themes.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </React.Fragment>
          )}
          {type === 'flowers' && (
            <React.Fragment>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>Size</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 250 }}
                    value={flowerSize}
                    label='Size'
                    onChange={(event) => setFlowerSize(event.target.value)}
                  >
                    {flowers.sizes.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>
                    Vase Color
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 350 }}
                    value={flowerVaseColor}
                    label='Vase Color'
                    onChange={(event) => setFlowerVaseColor(event.target.value)}
                  >
                    {flowers.vase_colors.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ mb: 1 }}>
                  <InputLabel id='demo-simple-select-label'>
                    Flower Color
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    sx={{ width: 350 }}
                    value={flowerFlowerColor}
                    label='Flower Color'
                    onChange={(event) =>
                      setFlowerFlowerColor(event.target.value)
                    }
                  >
                    {flowers.flower_colors.map((size) => (
                      <MenuItem value={size} key={size}>
                        {size.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </React.Fragment>
          )}
        </Container>
        <Container>
          <Typography
            sx={{ my: 1, fontSize: 30, mt: { xs: 5, md: 5 } }}
            variant='primary'
            component='div'
            align='center'
          >
            Describe what you would like for your custom piece. Feel free to
            attach picture(s) or website links for reference.
          </Typography>
          <TextField
            required
            multiline
            fullWidth
            rows={6}
            onChange={(event) => setDescription(event.target.value)}
            name='description'
            label='Description'
            type='description'
            id='description'
          />
        </Container>
        <div
          style={{
            padding: '10px',
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            alignContent: 'center',
          }}
        >
          <label htmlFor='upload-button'>
            <span className='fa-stack fa-2x mt-3 mb-2'>
              <i className='fas fa-circle fa-stack-2x' />
              <i className='fas fa-store fa-stack-1x fa-inverse' />
            </span>
            <h5 className='text-center'>Upload your photos & videos</h5>
            <h6 className='text-center'>
              Choose as many pictures as you would like to upload
            </h6>
          </label>
          <input type='file' id='upload-button' onChange={upload} multiple />
        </div>
        <div
          style={{
            padding: '10px',
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            alignContent: 'center',
            width: '75%',
          }}
        >
          {completed > 0 && <ProgressBar completed={completed} />}
          {onePhoto && (
            <Loader type='ThreeDots' color='#00BFFF' height={80} width={80} />
          )}
          {completed > 0 || (onePhoto && 'Do Not Refresh')}
        </div>
        <h3 style={{ marginTop: 10, color: 'green' }}>{successMessage}</h3>
        <h3 style={{ marginTop: 10, color: 'red' }}>{errorMessage}</h3>
        <Container
          maxWidth='md'
          component='main'
          sx={{
            display: 'flex',
            width: '100%',
            marginTop: 6,
            alignItems: 'center',
            justifyContent: 'space-around',
            flexDirection: 'column',
          }}
        >
          <AddressForm type='custom-order' />
        </Container>
        <Container
          disableGutters
          maxWidth='2xl'
          component='main'
          sx={{
            display: 'flex',
            width: '100%',
            marginTop: 6,
            alignItems: 'center',
            justifyContent: 'space-around',
            flexDirection: 'column',
          }}
        >
          <Button
            size='large'
            variant='contained'
            disabled={submitForApprovalDisabled}
            onClick={() => submitForApproval()}
          >
            Submit For Pricing
          </Button>
        </Container>
      </Container>
    </React.Fragment>
  );
}
